export const apiCreate = (): string => '/commercial/orders/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/orders/' : `/commercial/orders/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/orders/update/${id}`
export const apiDelete = (id: string): string => `/commercial/orders/${id}`
